import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalComponent, ShareReportDialogActions } from '@modeso/aumico-lib-core-fe';
import { ConfirmShareModalData } from '../../interfaces/confirm-share-modal-data.interface';

@Component({
    selector: 'app-confirm-share-report-dialog',
    templateUrl: './confirm-share-report-dialog.component.html',
    styleUrls: ['./confirm-share-report-dialog.component.scss'],
})
export class ConfirmShareReportDialogComponent extends ModalComponent implements OnInit {
    constructor(
        matIconRegistry: MatIconRegistry,
        domSanitizer: DomSanitizer,
        @Inject(MAT_DIALOG_DATA) public override data: ConfirmShareModalData,
        dialogRef: MatDialogRef<ConfirmShareReportDialogComponent, ShareReportDialogActions>,
    ) {
        super(matIconRegistry, domSanitizer, data, dialogRef);
    }
}
